import React, { useState, useEffect } from 'react';
import ChatAdminSelector from '../components/chatbot/ChatAdminSelector';
import ChatWindow from '../components/chatbot/ChatWindow';
import { chatApi } from '../api/chatApi';
import { useAuth } from '../hooks/useAuth';
import { useSocket } from '../hooks/useSocket';
import { MessageSquare, ChevronLeft } from 'lucide-react';

const Chatbot = () => {
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const { user } = useAuth();
  const { socket } = useSocket();

  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const res = await chatApi.getChatAdmins();
      setAdmins(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const filteredAdmins = admins.filter((a) => {
    const term = search.toLowerCase();
    return (
      a.name.toLowerCase().includes(term) ||
      (a.company && a.company.name.toLowerCase().includes(term))
    );
  });

  return (
    <div className="h-[calc(100vh-120px)] flex flex-col bg-white border border-slate-100 shadow-sm rounded-3xl overflow-hidden shadow-2xl animate-fadeIn">
      {/* Header Bar */}
      <div className="px-6 py-4 bg-white border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {selectedAdmin && (
            <button
              onClick={() => setSelectedAdmin(null)}
              className="p-1 rounded-lg text-slate-500 hover:text-slate-900 sm:hidden mr-1"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
          )}
          <div className="p-2 rounded-xl bg-green-700/20 text-green-700 border border-green-100">
            <MessageSquare className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-base font-bold text-slate-900 font-display">SuperAdmin Real-time Chat Workspace</h2>
            <p className="text-xs text-slate-500">Direct Socket.io messaging with tenant company admins</p>
          </div>
        </div>
      </div>

      {/* Main Split Layout */}
      <div className="flex-1 flex overflow-hidden">
        <div
          className={`w-full sm:w-80 flex-shrink-0 ${
            selectedAdmin ? 'hidden sm:block' : 'block'
          }`}
        >
          <ChatAdminSelector
            admins={filteredAdmins}
            selectedAdmin={selectedAdmin}
            onSelectAdmin={(admin) => setSelectedAdmin(admin)}
            loading={loading}
            search={search}
            onSearchChange={setSearch}
          />
        </div>

        <div className={`flex-1 ${!selectedAdmin ? 'hidden sm:flex' : 'flex'}`}>
          <ChatWindow
            selectedAdmin={selectedAdmin}
            currentUserId={user?._id}
            socket={socket}
          />
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
